import moment from "moment";
import TenderButton from './components/TenderButton';
import CustomDateTimePicker from '../../components/CustomDateTimePicker';
import CustomDatePicker from '../../components/CustomDatePicker';
import {
    convertYMDToMDY,
    convertMDYToYMD,
    convertMilitaryDateToYMD,
    convertMilitaryTimeToHHMM
} from '../../utils/global-functions';

export const todaysDate = moment().format('1YYMMDD');
export const apptDateGTE180d = moment().subtract(180, 'days').format('1YYMMDD');

export const loadsTableTabs = () => {
    let days = [];
    let daysRequired = 8

    for (let i = 0; i <= daysRequired; i++) {
        let dayName = moment().add(i, 'days').format('dddd');
        let obj = { id: i, dayDate: moment().add(i, 'days').format('1YYMMDD'), nextDayDate: moment().add(i + 1, 'days').format('1YYMMDD'), uniqKey: dayName.toLowerCase() }
        if (i === 0) {
            obj = { ...obj, label: 'Past/Today', uniqKey: (dayName === 'Saturday') ? 'satsun' : 'pasttoday' }
        } else if (i === 7) {
            obj = { ...obj, label: 'Future Loads', uniqKey: 'futureload' }
        } else if (i === 8) {
            obj = { ...obj, label: 'Unappointed', uniqKey: 'unappointed' }
        } else if (dayName === 'Saturday') {
            obj = { ...obj, label: 'Sat/Sun', uniqKey: 'satsun' }
        } else if (dayName === 'Sunday') {
            continue;
        } else {
            obj = { ...obj, label: dayName }
        }
        days.push(obj)
    }
    return days;
}

const commonTableColumn = [
    { field: 'io', headerName: 'I/O', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'spec', headerName: 'Spec', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'unit', headerName: 'Unit', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'chassisNumber', headerName: 'Chassis', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'ssl', headerName: 'SSL/Eqp', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'size', headerName: 'Size', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'puloc', headerName: 'PU Loc', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'rtnloc', headerName: 'RTN Loc', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'shipConsName', headerName: 'Shipper/Cgnee', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'cityState', headerName: 'City,ST', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
]

// const apptDatetimeComparator = (v1, v2) => {
  
//     const parsed1 = parseApptDateTime(v1);
//     const parsed2 = parseApptDateTime(v2);

//     if (parsed1 < parsed2) return -1;
//     if (parsed1 > parsed2) return 1;
//     return 0;
// };
const apptDatetimeComparator = (v1, v2) => {
    const parsed1 = parseApptDateTime(v1);
    const parsed2 = parseApptDateTime(v2);

    if (parsed1.dateValue !== parsed2.dateValue) {
        return parsed1.dateValue - parsed2.dateValue;
    }
    return parsed1.suffixValue - parsed2.suffixValue;
};


// const parseApptDateTime = (value) => {
//     if (!value || value.trim() === "") return Number.MAX_VALUE; // Push empty values to the bottom

//     const match = value.match(/^(\d{2}\/\d{2}\/\d{2})\s*(.*)?$/); // Extract date and suffix
//     if (!match) return Number.MAX_VALUE; // Fallback for invalid formats

//     const datePart = match[1]; // "02/28/25"
//     const timeOrText = match[2]?.trim(); // "AAA", "12:00", "8", etc.

//     // Convert date to a timestamp
//     const date = new Date(datePart);
//     if (isNaN(date.getTime())) return Number.MAX_VALUE;

//     // Handle time values
//     if (timeOrText) {
//         if (/^\d+$/.test(timeOrText)) {
//             // Convert numeric time (e.g., "8" -> 08:00, "50" is treated as higher)
//             return date.getTime() + parseInt(timeOrText, 10) * 60000;
//         }
//         if (/^\d+:\d+$/.test(timeOrText)) {
//             // Convert HH:MM format (e.g., "12:00")
//             const [hours, minutes] = timeOrText.split(":").map(Number);
//             return date.getTime() + (hours * 60 + minutes) * 60000;
//         }
//         // If it's a string (AAA, ABCD, etc.), sort it first but keep ordering
//         return date.getTime() - timeOrText.charCodeAt(0) * 100000;
//     }

//     return date.getTime(); // Return only date if no suffix exists
// };

// const parseApptDateTime = (value) => {
//     if (!value || value.trim() === "") {
//         return { dateValue: Number.MAX_VALUE, suffixValue: Number.MAX_VALUE };
//     }

//     const match = value.match(/^(\d{2}\/\d{2}\/\d{2})\s*(.*)?$/);
//     if (!match) {
//         return { dateValue: Number.MAX_VALUE, suffixValue: Number.MAX_VALUE };
//     }

//     const datePart = match[1]; // e.g., "04/18/25"
//     const suffix = match[2]?.trim() || "";

//     const date = new Date(datePart);
//     if (isNaN(date.getTime())) {
//         return { dateValue: Number.MAX_VALUE, suffixValue: Number.MAX_VALUE };
//     }

//     const dateValue = date.getTime();

//     // Assign a numeric value to the suffix to help with consistent sorting
//     const getSuffixValue = (text) => {
//         if (text === "") return 90000;

//         // Format: HH:MM
//         if (/^\d{1,2}:\d{2}$/.test(text)) {
//             const [h, m] = text.split(":").map(Number);
//             return 100000 + h * 60 + m;
//         }

//         // Format: single or double digit hour (e.g., "8", "12")
//         if (/^\d{1,2}$/.test(text)) {
//             return 200000 + parseInt(text) * 60; // treat as minutes
//         }

//         // Format: 6 digit military time (e.g., 081200)
//         if (/^\d{6}$/.test(text)) {
//             return 300000 + parseInt(text);
//         }

//         // Format: 08-1200 or similar
//         if (/^\d{2}-\d{4}$/.test(text)) {
//             const [h, m] = text.split("-");
//             return 400000 + parseInt(h) * 60 + parseInt(m);
//         }

//         // Format: 0800/PU# or similar
//         if (/^\d{4}\/[A-Z]+#?$/i.test(text)) {
//             const [time, code] = text.split("/");
//             return 500000 + parseInt(time) * 10 + (code.charCodeAt(0) || 0);
//         }

//         // Format: 0812/PA7# or PB6#
//         if (/^\d{4}\/[A-Z]+\d+#?$/i.test(text)) {
//             const [time, code] = text.split("/");
//             return 600000 + parseInt(time) * 100 + code.toUpperCase().charCodeAt(2); // PA7, PB6 → 'A' = 65, 'B' = 66
//         }

//         // Plain text like PULL or any unknown format
//         return 0 + text.toUpperCase().charCodeAt(0);
//     };

//     return { dateValue, suffixValue: getSuffixValue(suffix) };
// };

const parseApptDateTime = (value) => {
    if (!value || value.trim() === "") {
        return { dateValue: Number.MAX_VALUE, suffixValue: Number.MAX_VALUE };
    }

    const match = value.match(/^(\d{2}\/\d{2}\/\d{2})\s*(.*)?$/);
    if (!match) {
        return { dateValue: Number.MAX_VALUE, suffixValue: Number.MAX_VALUE };
    }

    const datePart = match[1]; // e.g., "04/18/25"
    const suffix = match[2]?.trim() || "";

    const date = new Date(datePart);
    if (isNaN(date.getTime())) {
        return { dateValue: Number.MAX_VALUE, suffixValue: Number.MAX_VALUE };
    }

    const dateValue = date.getTime();

    const getSuffixValue = (text) => {
        if (text === "") return 0;

        // If it starts with a letter, prioritize it by giving it the lowest base
        if (/^[A-Za-z]/.test(text)) {
            return 10000 + text.toUpperCase().charCodeAt(0); // lower than all numeric formats
        }

        // Format: HH:MM
        if (/^\d{1,2}:\d{2}$/.test(text)) {
            const [h, m] = text.split(":").map(Number);
            return 100000 + h * 60 + m;
        }

        // Format: single or double digit hour (e.g., "8", "12")
        if (/^\d{1,2}$/.test(text)) {
            return 200000 + parseInt(text) * 60;
        }

        // Format: 6 digit military time (e.g., 081200)
        if (/^\d{6}$/.test(text)) {
            return 300000 + parseInt(text);
        }

        // Format: 08-1200 or similar
        if (/^\d{2}-\d{4}$/.test(text)) {
            const [h, m] = text.split("-");
            return 400000 + parseInt(h) * 60 + parseInt(m);
        }

        // Format: 0800/PU# or similar
        if (/^\d{4}\/[A-Z]+#?$/i.test(text)) {
            const [time, code] = text.split("/");
            return 500000 + parseInt(time) * 10 + (code.charCodeAt(0) || 0);
        }

        // Format: 0812/PA7# or PB6#
        if (/^\d{4}\/[A-Z]+\d+#?$/i.test(text)) {
            const [time, code] = text.split("/");
            return 600000 + parseInt(time) * 100 + code.toUpperCase().charCodeAt(2);
        }

        // Fallback for unknown formats
        return 900000 + text.toUpperCase().charCodeAt(0);
    };

    return { dateValue, suffixValue: getSuffixValue(suffix) };
};



export const loadsTableColumns = [
    { field: 'stop', headerName: 'Stop', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell' },
    { field: 'control', headerName: 'Control', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true, renderCell: (params) => (<TenderButton {...params} type='loads' btnLabel={`T`} />) },
    { field: 'io', headerName: 'I/O', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'puloc', headerName: 'PU Loc', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'unit', headerName: 'Unit', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'chassisNumber', headerName: 'Chassis', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    {
        field: 'apptDateTime',
        headerName: 'Appt Date/Time',
        headerClassName: 'MuiDataGrid-columnHeaders',
        cellClassName: 'super-app-theme--cell',
        disableColumnMenu: true,
        renderCell: (params) => params.row.apptDateTime,
        valueGetter: (params) => params.row.apptDateTime,
        sortComparator: apptDatetimeComparator,
        minWidth: 110
    },
    { field: 'shipConsName', headerName: 'Shipper/Cgnee', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'cityState', headerName: 'City,ST', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'rtnloc', headerName: 'RTN Loc', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'etaDateTime', headerName: 'ETA', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'notifyDateTime', headerName: 'Notify/ERD', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'lfdcut', headerName: 'LFD/CUT', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'release', headerName: 'Release/Bkg#', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'spec', headerName: 'Spec', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'ssl', headerName: 'SSL/Eqp', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'size', headerName: 'Size', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true }
]

export const spottedTableColumns = [
    { field: 'stop', headerName: 'Stop', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell' },
    { field: 'control', headerName: 'Control', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true, renderCell: (params) => (<TenderButton {...params} type='spotted' btnLabel={`T`} />) },
    ...commonTableColumn,
    { field: 'outageDateTime', headerName: 'Outage Date/Time', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'spotDateTime', headerName: 'Spotted Date/Time', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    {
        field: 'availDateTime',
        headerName: 'Avail Date/Time',
        headerClassName: 'MuiDataGrid-columnHeaders',
        cellClassName: 'super-app-theme--cell',
        disableColumnMenu: true,
        editable: true,
        renderCell: (params) => params.row.availDateTime,
        sortComparator: apptDatetimeComparator,
        minWidth: 110,
        editable: true,
        renderEditCell: (params) => {
            // Convert the MM/DD/YYYY date and time to ISO format for the picker
            const extractDate = convertMilitaryDateToYMD(params.row.availDate)
            const apiResTime = convertMilitaryTimeToHHMM(params.row.availTime)
            const isoFormattedDate = `${extractDate}T${apiResTime}`;
            return (
                <CustomDateTimePicker
                    variant="standard"
                    size="small"
                    className="width_100"
                    value={isoFormattedDate || ''}
                    onValueChange={(selectedVal) => {
                        const formattedDate = convertYMDToMDY(selectedVal.eDate) || ''; // Convert to MM/DD/YYYY
                        const formattedTime = selectedVal.eTime || '';
                        params.api.setEditCellValue({
                            id: params.id,
                            field: params.field,
                            value: `${formattedDate} ${formattedTime}`
                        });
                    }}
                    hasFocus={params.hasFocus}
                    isArrowKeyDisabled={true}
                    showOneMonthAlert={true}
                />
            );
        },
        valueGetter: (params) => {
            if (params.row?.availDateTime === undefined || params.row?.availDateTime === null) {
                console.warn('Missing availDateTime:', params.row);
                return '';
            }
            return params.row.availDateTime;
        }
    },
    {
        field: 'lastFreeDay',
        headerName: 'Last Diem Day',
        headerClassName: 'MuiDataGrid-columnHeaders',
        cellClassName: 'super-app-theme--cell',
        disableColumnMenu: true,
        editable: true,
        minWidth: 160,
        flex: 1,
        renderCell: (params) => {
            return params.row.lastFreeDay ? convertYMDToMDY(params.row.lastFreeDay) : '';
        },
        renderEditCell: (params) => (
            <CustomDatePicker
                size="small"
                className="width_100"
                variant="standard"
                value={params.row.lastFreeDay ? convertMDYToYMD(params.row.lastFreeDay) : ''}
                onValueChange={(selectedVal) => {
                    params.api.setEditCellValue({
                        id: params.id,
                        field: params.field,
                        value: convertYMDToMDY(selectedVal) // Ensure MM/DD/YYYY format
                    });
                }}
                hasFocus={params.hasFocus}
                isArrowKeyDisabled={true}
            />
        ),
        minWidth: 130,
        flex: 1,
        valueGetter: (params) => {
            const datePart = convertMDYToYMD(params.row.lastFreeDay);
            return datePart;
        },
        sortComparator: (v1, v2) => {
            // Ensure values are valid Date objects before comparing
            const date1 = v1 instanceof Date ? v1 : new Date(v1);
            const date2 = v2 instanceof Date ? v2 : new Date(v2);
            return date1 - date2;
        },
    }
]

export const subItemTableColumns = [
    { field: 'stop', headerName: 'Stop', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell' },
    {
        field: 'control', headerName: 'Control', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true, minWidth: 91,
        renderCell: (params) => (<TenderButton {...params} type='driver' btnLabel={`T`} />)
    },
    { field: 'io', headerName: 'I/O', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'spec', headerName: 'Spec', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'unit', headerName: 'Unit', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'chassisNumber', headerName: 'Chassis', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    {
        field: 'apptDateTime',
        headerName: 'Appt Date/Time',
        headerClassName: 'MuiDataGrid-columnHeaders',
        cellClassName: 'super-app-theme--cell',
        disableColumnMenu: true,
        renderCell: (params) => params.row.apptDateTime,
        valueGetter: (params) => params.row.apptDateForSort,
        sortComparator: apptDatetimeComparator,
        minWidth: 110
    },
    { field: 'ssl', headerName: 'SSL/Eqp', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'size', headerName: 'Size', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'puloc', headerName: 'PU Loc', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'rtnloc', headerName: 'RTN Loc', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'shipConsName', headerName: 'Shipper/Cgnee', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'cityState', headerName: 'City,ST', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', disableColumnMenu: true },
    { field: 'lfdcut', headerName: 'LFD/CUT', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', editable: false, disableColumnMenu: true, minWidth: 110 },
    { field: 'tenderType', headerName: 'Type', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', editable: false, disableColumnMenu: true },
    { field: 'lastEvent', headerName: 'Last Event', headerClassName: 'MuiDataGrid-columnHeaders', cellClassName: 'super-app-theme--cell', editable: false, disableColumnMenu: true },
]

export function validateHhMm(inputField) {
    var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(inputField);
    if (isValid) {
        return true;
    } else {
        return false;
    }
}

export function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export const setRowOrderByCookie = (truck, arr) => {
    let reOrder = arr.map((v, i) => ({ ...v, displayPosition: i }))
    localStorage.setItem(truck, JSON.stringify(reOrder));
}

export const updateRowOrderByCookie = (truck, arr) => {
    localStorage.setItem(truck, JSON.stringify(arr));
}

export const getRowOrderFromCookie = (truck) => {
    const arrFromCookie = JSON.parse(localStorage.getItem(truck));
    return arrFromCookie?.length > 0 ? arrFromCookie : [];
}

